/**
 * 家校通路由配置
 */
export default [
  {
    path: '/school-home',
    name: 'SchoolHomeIndex',
    component: () => import('@/views/school-home/index.vue'),
    meta: { title: '家校通' }
  },
  {
    path: '/school-home/login',
    name: 'SchoolHomeLogin',
    component: () => import('@/views/school-home/login.vue'),
    meta: { title: '家校通登录' }
  },
  {
    path: '/school-home/student',
    name: 'HomeSchoolStudent',
    component: () => import('@/views/school-home/student.vue'),
    meta: { title: '家校通' }
  },
  {
    path: '/school-home/student-daily',
    name: 'SchoolHomeStudentDaily',
    component: () => import('@/views/school-home/studentDaily.vue'),
    meta: { title: '家校通' }
  },
  {
    path: '/school-home/student-grade-daily',
    name: 'SchoolHomeStudentGradeDaily',
    component: () => import('@/views/school-home/studentGradeDaily.vue'),
    meta: { title: '家校通' }
  },
  {
    path: '/school-home/student-grade-unified',
    name: 'SchoolHomeStudentGradeUnified',
    component: () => import('@/views/school-home/studentGradeUnified.vue'),
    meta: { title: '家校通' }
  }
]
